<template>
   <div>
      <div class="section-header d-flex align-items-center justify-content-between mb-4">
         <h6 class="mb-0">Contractors</h6>
         <b-button
            v-if="!isSME && hasContractorPaymentsAccess"
            type="button"
            style="width: 7.5rem"
            class="action-button dark-button btn-primary"
            variant="primary"
            @click="addNewContractor"
            >Add New +</b-button
         >
      </div>

      <div
         id="contractors-tab-panel"
         class="contractor-list"
         role="tabpanel"
         style="max-height: 26.5rem; overflow-y: auto"
      >
         <div
            v-for="(contractor, idx) in contractors"
            :key="idx"
            class="contractor-item d-flex align-items-center justify-content-between"
         >
            <div class="left d-flex align-items-center">
               <button
                  type="button"
                  class="icon-btn handle mr-2"
                  aria-label="Reorder"
                  @click="editContractor(contractor)"
               >
                  <b-icon-pencil
                     style="width: 1rem; height: 1rem"
                     icon="archive"
                     aria-hidden="true"
                  ></b-icon-pencil>
               </button>
               <div class="meta">
                  <div class="name">{{ contractor.name }}</div>
                  <div class="sub">
                     {{ ContractTypes[contractor.contractType] }} |
                     {{ states[contractor.location] }}
                  </div>
               </div>
            </div>

            <div v-if="!isSME && !isComplete" class="right d-flex align-items-center">
               <button
                  type="button"
                  class="icon-btn trash-icon-btn"
                  aria-label="Delete"
                  @click="deleteContractor(contractor)"
               >
                  <b-icon style="width: 1rem; height: 1rem" icon="trash" />
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {ContractTypes} from '@/store/models/contractor';
import {expensePermissionsMixin} from '@/mixins';

export default {
   name: 'ContractorList',
   mixins: [expensePermissionsMixin],
   computed: {
      ContractTypes() {
         return ContractTypes;
      },
      ...mapGetters({
         isSME: 'isSME',
         isCustomer: 'isCustomer',
         profile: 'profile',
         states: 'usStatesOutsideUS',
         contractorsList: 'contractors/manualVendors',
         isComplete: 'contractors/isCompleted',
      }),

      contractors() {
         const list = this.contractorsList || [];
         if (this.isSME) {
            return list.filter(({assigneeId}) => assigneeId === this.profile.id);
         }
         return list;
      },
   },

   methods: {
      addNewContractor() {
         this.$emit('onAddNewContractor');
      },

      editContractor(contractor) {
         this.$emit('onEditContractor', contractor);
      },

      /** Delete a contractor */
      async deleteContractor(contractor) {
         const proceed = await this.$bvModal.msgBoxConfirm(
            `Are you sure you want to delete "${contractor.name}" and any associated data?`,
            {
               id: 'modal-delete-contractor',
               title: 'Delete this contract researcher?',
               centered: true,
               buttonSize: 'sm',
               contentClass: 'delete-contractor-modal-content',
               headerClass: 'delete-contractor-modal-header',
               footerClass: 'delete-contractor-modal-footer',
            }
         );
         if (proceed) {
            await this.blockingRequest('contractors/deleteManualVendor', {
               vendorId: contractor.id,
               force: proceed,
            });
            await this.$store.commit('contractorTime/clearContractorData', {
               contractorId: contractor.id,
            });
         }
      },
   },
};
</script>

<style scoped lang="scss">
.section-header h6 {
   font-size: 1rem;
   font-weight: 700;
   color: #101828;
}

.contractor-list {
   margin-top: 0.375rem;
}

.contractor-item {
   background: #f8fafc;
   border: 1px solid #eef2f7;
   border-radius: 0.5rem;
   padding: 0.75rem 0.75rem;
   margin-bottom: 0.5rem;
}

.contractor-item .meta .name {
   font-size: 0.75rem;
   font-weight: 600;
   color: #101828;
   margin-bottom: 0.125rem;
}

.contractor-item .meta .sub {
   font-size: 0.75rem;
   font-weight: 400;
   color: #667085;
}

.icon-btn {
   border: none;
   background: transparent;
   color: #98a2b3;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   transition: background 0.12s ease, color 0.12s ease;
   cursor: pointer;
}

.icon-btn:hover {
   background: #eef2f7;
   color: #667085;
}

.trash-icon-btn:hover {
   color: $danger;
}

.action-button {
   font-size: 0.75rem;
}

::v-deep .delete-contractor-modal-content {
   font-size: 0.75rem;
   font-weight: 400;
}

::v-deep .delete-contractor-modal-footer .btn {
   font-size: 0.75rem;
}

::v-deep .delete-contractor-modal-header .modal-title {
   font-size: 1.25rem !important;
}
</style>
